import { UsuarioApi } from 'Services/api/usuario/types'
import { Usuario } from './types'

const ajustarUsuario = (usuario: UsuarioApi): Usuario => {
  const { idtabelaprecopadrao_str, idusuario_str, ...propriedades } = usuario

  return {
    ...propriedades,
    idtabelaprecopadrao: idtabelaprecopadrao_str,
    idusuario: idusuario_str,
  }
}

export default ajustarUsuario
